import TransportsController from './transports.controller';

export default {
    template: require('./transports.tpl.html'),
    controller: TransportsController
};
